import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DropdownOption } from '../models/shared/dropdown-option';
import { HttpUtil } from '../utils/http-util';
import { environment } from '../../environments/environment';
import { CacheService } from './cache.service';

@Injectable({
  providedIn: 'root'
})
export class DropdownService {
  constructor(
    private _http: HttpClient,
    private cacheService: CacheService
  ) { }

  public GetOptions(name: string,
    typeId: number | null = null,
    searchTerm?: string,
    skipCache: boolean = false): Observable<DropdownOption[]> {
    
    // Crear una clave única para la caché basada en los parámetros
    const cacheKey = `dropdown_${name}_${typeId || 'null'}_${searchTerm || ''}`;
    
    // Verificar si los datos están en caché y no se ha solicitado bypass
    if (!skipCache) {
      const cachedData = this.cacheService.get(cacheKey);
      if (cachedData) {
        console.log(`[Cache] Usando datos en caché para: ${name}`);
        return of(cachedData);
      }
    } else {
      console.log(`[Cache] Bypass solicitado para: ${name}`);
    }
    
    // Si no están en caché o se solicitó bypass, hacer la petición HTTP
    console.log(`[Cache] Solicitando datos del servidor para: ${name}`);
    return this._http.get<DropdownOption[]>(`${environment.api.url}/Dropdown/GetOptions`, {
      params: HttpUtil.toHttpParams({
        name: name,
        typeId: typeId,
        searchTerm: searchTerm
      })
    }).pipe(
      tap(data => {
        // Guardar los datos en caché con un TTL de 1 hora (valor por defecto)
        // Siempre actualizamos la caché, incluso si se solicitó bypass
        this.cacheService.set(cacheKey, data);
        if (skipCache) {
          console.log(`[Cache] Datos actualizados en caché para: ${name}`);
        }
      })
    );
  }

}
